import React from "react";
import {LockIcon} from "./LockIcon";
import BukkuTooltip from "../../Tooltip";
import {Trans} from "@lingui/macro";
import styled from 'styled-components';

export const Styled = styled.span`
  display: flex;

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .flex-grow {
    flex-grow: 1;
  }
`;

// export const StyledBadge = styled(Badge)``

export function LockTooltip(props) {
    const {
        children,
        withIcon,
        title: overrideTitle,
        fullWidth, // whether to let contents fill width of the container.  (eg Report cards in reports page)
        hoverPopupBehavior = 'entireDiv', // 'entireDiv' | 'lockIconOnly' -- whether to show tooltip when hovering over entire div (label+icon) or just the lock icon
        ...restProps
    } = props;

    const title = overrideTitle || (
        <span>
            <Trans>
                Not available in your&nbsp;
                <br />
                subscription plan.
            </Trans>
        </span>
    );

    // const delay = 0.5;

    if (children) {
        switch (hoverPopupBehavior) {
            case 'entireDiv':

                return (
                    <BukkuTooltip
                        {...restProps}
                        title={title}
                        popupContainerId="subscription-lock-icon"
                    >
                        <Styled className="subscription-lock-wrapper">
                            <span className={`label ${fullWidth ? 'flex-grow' : ''}`}>
                                {children}
                            </span>
                            {withIcon ? (
                                <span className="lock-icon">
                                    &nbsp;
                                    <LockIcon />
                                </span>
                            ) : null}
                        </Styled>
                    </BukkuTooltip>
                );
            case 'lockIconOnly':
            default:
                return (

                    <span className="subscription-lock-wrapper">
                        {children}
                        <BukkuTooltip
                            {...restProps}
                            title={title}
                            popupContainerId="subscription-lock-icon"
                        >
                            {withIcon ? (
                                <>
                                    &nbsp;
                                    <LockIcon />
                                </>
                            ) : null}
                        </BukkuTooltip>
                    </span>
                );
        }
    }
    return (
        <BukkuTooltip
            {...restProps}
            title={title}
            popupContainerId="subscription-lock-icon"
        >
            <span className="subscription-lock-wrapper"><LockIcon /></span>
        </BukkuTooltip>
    );
}
